import { policyDetailsFromSegments } from '@ourbranch/policy-utils';

export const getInitialValues = ({ policyType }) => {
  const initialValuesForPolicyType = {
    H: {
      home: false,
      homeCoverage: false,
      people: false,
      clarionDoorIdOverride: false
    },
    C: {
      condo: false,
      condoCoverage: false,
      people: false,
      clarionDoorIdOverride: false
    },
    A: {
      auto: false,
      autoCoverage: false,
      drivers: false,
      cars: false,
      trailers: false,
      clarionDoorIdOverride: false
    },
    R: {
      renters: false,
      rentersCoverage: false,
      people: false,
      clarionDoorIdOverride: false
    }
  };
  return { ...initialValuesForPolicyType[policyType] };
};

export const optionsForPolicyType = {
  H: [
    { id: 'home', value: 'Home Characteristics' },
    { id: 'homeCoverage', value: 'Home Coverages' },
    { id: 'people', value: 'People' }
  ],
  C: [
    { id: 'condo', value: 'Condo Characteristics' },
    { id: 'condoCoverage', value: 'Condo Coverages' },
    { id: 'people', value: 'People' }
  ],
  A: [
    { id: 'auto', value: 'Auto Characteristics' },
    { id: 'autoCoverage', value: 'Auto Coverages' },
    { id: 'drivers', value: 'Drivers' },
    { id: 'trailers', value: 'Trailers' },
    { id: 'cars', value: 'Cars' }
  ],
  R: [
    { id: 'rentersCoverage', value: 'Renters Coverages' },
    { id: 'people', value: 'People' }
  ]
};

export const getUpdatedPolicyValues = ({ policy, policyFromVersion, nodesToUpdate, selectedSegmentStartDate }) => {
  const policyDetailsFromVersion = policyDetailsFromSegments(policyFromVersion);
  const currentSegment = policy.segments.find((s) => s.startDate === selectedSegmentStartDate);

  // HOME NODES
  if (nodesToUpdate.includes('homeCoverage')) {
    currentSegment.homeCoverage = policyDetailsFromVersion.homeCoverage;
  }
  if (nodesToUpdate.includes('home')) {
    currentSegment.home = policyDetailsFromVersion.home;
  }

  // AUTO NODES
  if (nodesToUpdate.includes('auto')) {
    currentSegment.auto = policyDetailsFromVersion.auto;
  }
  if (nodesToUpdate.includes('autoCoverage')) {
    currentSegment.autoCoverage = policyDetailsFromVersion.autoCoverage;
  }
  if (nodesToUpdate.includes('drivers')) {
    currentSegment.drivers = policyDetailsFromVersion.drivers;
  }
  if (nodesToUpdate.includes('cars')) {
    currentSegment.cars = policyDetailsFromVersion.cars;
  }
  if (nodesToUpdate.includes('trailers')) {
    currentSegment.trailers = policyDetailsFromVersion.trailers;
  }

  // RENTERS NODES
  if (nodesToUpdate.includes('rentersCoverage')) {
    currentSegment.rentersCoverage = policyDetailsFromVersion.rentersCoverage;
  }

  // CONDO NODES
  if (nodesToUpdate.includes('condo')) {
    currentSegment.condo = policyDetailsFromVersion.condo;
  }
  if (nodesToUpdate.includes('condoCoverage')) {
    currentSegment.condoCoverage = policyDetailsFromVersion.condoCoverage;
  }

  // PEOPLE NODES
  if (nodesToUpdate.includes('people')) {
    currentSegment.people = policyDetailsFromVersion.people;
  }

  // CLARIONDOOR ID OVERRIDE
  // Extract the clarionDoorId from the version segment
  if (nodesToUpdate.includes('clarionDoorIdOverride')) {
    const versionSegment =
      policyFromVersion.segments.find((s) => s.startDate === selectedSegmentStartDate) ||
      policyFromVersion.segments[policyFromVersion.segments.length - 1];
    currentSegment.clarionDoorIdOverride = versionSegment?.clarionDoorId;
  }

  return currentSegment;
};
